export default __webpack_public_path__ + "static/media/bgn.5e32be1b.png";